import BeatLoader from 'react-spinners/BeatLoader';

const override = {
  display: 'flex',
  margin: '0 auto',
  borderColor: '#114cb3',
  width: 'auto',
};

const Spinner = ({ loading }) => {
  return (
    <BeatLoader
      color={'#114cb3'}
      loading={loading}
      cssOverride={override}
      size={20}
      data-testid='loader'
    />
  );
};

export default Spinner;
